import api from '../base';
import { WebEdiConfiguration, WebEdiIntegrationSettings } from './webEdiApiTypes';
import { mockGetWebEdiConfigurations, mockGetWebEdiIntegrationSettingsResponse } from './webEdiMock';

const BASE_PATH = 'management/web-edi';

// eslint-disable-next-line import/prefer-default-export
export async function getWebEdiConfigurations(
  signal?: AbortSignal,
): Promise<WebEdiConfiguration[]> {
  return api.get<WebEdiConfiguration[]>(`${BASE_PATH}/configurations`, {
    signal,
  })
    .then(response => response.data);
}

api.mock
  .onGet('management/web-edi/configurations')
  .reply(200, mockGetWebEdiConfigurations);

export async function getWebEdiIntegrationSettings(): Promise<WebEdiIntegrationSettings> {
  return api.get<WebEdiIntegrationSettings>(`${BASE_PATH}/partner-integration-settings`).then(response => response.data);
}

api.mock.onGet('/management/web-edi/partner-integration-settings').reply(200, mockGetWebEdiIntegrationSettingsResponse);

export async function saveWebEdiIntegrationSettings(
  settings: WebEdiIntegrationSettings,
): Promise<string> {
  return api.post<string>(`${BASE_PATH}/partner-integration-settings`, settings).then(response => response.data);
}

api.mock.onPost('management/web-edi/partner-integration-settings').reply(202);
